export enum ChartTooltipSide {
    Top = "top",
    Right = "right",
    Bottom = "bottom",
    Left = "left",
}
